export const getSaveInWallet = (
  setAsDefault?: boolean,
  saveInWallet?: boolean,
  hostPayload?: boolean
): boolean => {
  return !!(setAsDefault || saveInWallet || hostPayload);
};
